// import ReportsRepository from '@/libs/axios'
import ReportsRepository from '@/libs/customAxios/reportsAxios'
import DashboardRepository from '@/libs/customAxios/dashboardAxios'

const monthlySalesReportResource = '/admin/report/monthly-sales-report'
const merchantStatusCountReport = '/admin/report/merchant-status-count-report'
const merchantStatusCountReportV2 = '/admin/report/merchant-status-count-report-v2'
const branchStatusCountReport = '/admin/report/warehouse/branch-status-count-report'
const agencyStatusCountReport = '/admin/report/warehouse/branch-status-count-report'
const warehosueStatusCountReport = '/admin/report/warehouse-status-count-report'
const warehosueStatusCountReportV2 = '/admin/report/warehouse-status-count-report-v2'
const assignOrderDeliveryRiderReport = '/admin/report/assigned-orders-to-delivery-rider-report'
const assignOrderPickupRiderReport = '/admin/report/assigned-orders-to-pickup-rider-report'
const assignOrderRescheduledReport = '/admin/report/assigned-orders-rescheduled-report'
const assignOrderRescheduledReportV2 = '/admin/report/assigned-orders-rescheduled-report-v2'
const returnOrdersMerchantReport = '/admin/report/return-order-merchant-report'
const returnOrdersMerchantReportV2 = '/admin/report/return-order-merchant-report-v2'
const returnOrderWarehouseReport = '/admin/report/orders-assigned-to-warehouse-report'
const returnOrderWarehouseReportV2 = '/admin/report/orders-assigned-to-warehouse-report-v2'
const returnOrderOriginWarehouseReport = '/admin/report/orders-returned-to-origin-warehouse-report'
const returnOrderOriginWarehouseReportV2 = '/admin/report/orders-returned-to-origin-warehouse-report-v2'
const receivedOrderOriginWarehouseReport = '/admin/report/received-orders-to-origin-warehouse-report'
const returnOrderOriginWarehouseReportId = '/admin/report/orders-returned-to-origin-warehouse-id-report'
const returnOrderOriginWarehouseReportIdV2 = '/admin/report/orders-returned-to-origin-warehouse-id-report-v2'
const branchExpensesReport = '/admin/report/branch-expenses-report'
const branchProgressReport = '/admin/report/branch-progress-report'
const toBeInvoicedReport = '/admin/report/to-be-invoiced-report'
const zeroReturnClientReport = '/admin/report/zero-return-client-report'
const monthlySalesReportOverviewResource = '/admin/report/monthly-sales-report-overview'
const currentMonthlySalesReportResource = '/admin/report/current-monthly-sales-report'
const operationsRescheduleReport = '/admin/report/operations-reschedule-report'
const branchDeliveryDashboardResource = '/admin/dashboard/branch-delivery-progress'
const temporaryWarehouseReport = '/admin/report/temporary-warehouse-report'
const merchantInactivationReport = '/admin/report/merchant-inactivation-report'

const defaultPagination = 10
export default {
  getmonthlySalesReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${monthlySalesReportResource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=-id`)
  },
  getmonthlySalesReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${monthlySalesReportResource}?${filterQuery}&sort=-id&noPagination`)
  },
  getbranchStatusCountReport() {
    return ReportsRepository.get(`${branchStatusCountReport}?sort=-id`)
  },
  getagencyStatusCountReport() {
    return ReportsRepository.get(`${agencyStatusCountReport}?sort=-id`)
  },
  getWarehouseStatusCountReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${warehosueStatusCountReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getWarehouseStatusCountReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${warehosueStatusCountReport}?${filterQuery}&noPagination`)
  },
  getWarehouseStatusCountReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${warehosueStatusCountReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getWarehouseStatusCountReportV2NoPagination(filterQuery) {
    return ReportsRepository.get(`${warehosueStatusCountReportV2}?${filterQuery}&noPagination`)
  },
  getFilteredWarehouseStatusCountReport(id) {
    return ReportsRepository.get(`${warehosueStatusCountReport}?filter[current_warehouse]=${id},`)
  },
  getmerchantStatusCountReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${merchantStatusCountReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getmerchantStatusCountReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${merchantStatusCountReport}?${filterQuery}&noPagination`)
  },
  getmerchantStatusCountReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${merchantStatusCountReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getmerchantStatusCountReportV2NoPagination(filterQuery) {
    return ReportsRepository.get(`${merchantStatusCountReportV2}?${filterQuery}&noPagination`)
  },
  getAssignOrderDeliveryRiderReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${assignOrderDeliveryRiderReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAssignOrderDeliveryRiderReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${assignOrderDeliveryRiderReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getAssignOrderPickupRiderReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${assignOrderPickupRiderReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAssignOrderPickupRiderReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${assignOrderPickupRiderReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getAssignOrderRescheduledReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${assignOrderRescheduledReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAssignOrderRescheduledReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${assignOrderRescheduledReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getAssignOrderRescheduledReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${assignOrderRescheduledReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAssignOrderRescheduledReportV2NoPagiantion(filterQuery) {
    return ReportsRepository.get(`${assignOrderRescheduledReportV2}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnedOrderMerchantReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrdersMerchantReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnedOrderMerchantReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrdersMerchantReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnedOrderMerchantReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrdersMerchantReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnedOrderMerchantReportV2NoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrdersMerchantReportV2}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderWarehouseReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderWarehouseReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderWarehouseReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderWarehouseReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderWarehouseReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderWarehouseReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderWarehouseReportV2NoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderWarehouseReportV2}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderOriginWarehouseReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderOriginWarehouseReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderOriginWarehouseReportV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderOriginWarehouseReportV2NoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportV2}?${filterQuery}&sort=-id&noPagination`)
  },
  getreceivedOrderOriginWarehouseReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${receivedOrderOriginWarehouseReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreceivedOrderOriginWarehouseReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${receivedOrderOriginWarehouseReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderOriginWarehouseReportId(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportId}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderOriginWarehouseReportIdNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportId}?${filterQuery}&sort=-id&noPagination`)
  },
  getreturnOrderOriginWarehouseReportIdV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportIdV2}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getreturnOrderOriginWarehouseReportIdV2NoPagiantion(filterQuery) {
    return ReportsRepository.get(`${returnOrderOriginWarehouseReportIdV2}?${filterQuery}&sort=-id&noPagination`)
  },
  getBranchExpensesReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${branchExpensesReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getBranchExpensesReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${branchExpensesReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getBranchProgressReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${branchProgressReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getBranchProgressReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${branchProgressReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getToBeInvoicedReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${toBeInvoicedReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getToBeInvoicedReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${toBeInvoicedReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getReturnFreeMerchantsReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${zeroReturnClientReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getReturnFreeMerchantsReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${zeroReturnClientReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getmonthlySalesReportOverview() {
    return DashboardRepository.get(`${monthlySalesReportOverviewResource}`)
  },
  getCurrentMonthlySalesReport() {
    return ReportsRepository.get(`${currentMonthlySalesReportResource}`)
  },
  getOperationsRescheduleReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${operationsRescheduleReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getOperationsRescheduleReportNoPagiantion(filterQuery) {
    return ReportsRepository.get(`${operationsRescheduleReport}?${filterQuery}&sort=-id&noPagination`)
  },
  fetchReportDownloads(filterQuery, pageNumber = 1, pagination = defaultPagination) {
    return ReportsRepository.get(`/admin/report/get-queued-reports?${filterQuery}&page=${pageNumber}&paginate=${pagination}`, {
    })
  },
  fetchReportDownloadsNoPagination(filterQuery) {
    return ReportsRepository.get(`/admin/report/get-queued-reports?${filterQuery}`, {
    })
  },
  fetchInvoiceReportDownloads(filterQuery, pageNumber = 1, pagination = defaultPagination) {
    return ReportsRepository.get(`/admin/report/get-invoice-queued-reports?${filterQuery}&page=${pageNumber}&paginate=${pagination}`, {
    })
  },
  fetchInvoiceReportDownloadsNoPagination(filterQuery) {
    return ReportsRepository.get(`/admin/report/get-invoice-queued-reports?${filterQuery}`, {
    })
  },
  fetchAssignedOrderReportDownloads(filterQuery, pageNumber = 1, pagination = defaultPagination, queueReportType = '') {
    const typeFilter = queueReportType ? `filter[report_type]=${encodeURIComponent(queueReportType)}&` : ''
    return ReportsRepository.get(`/admin/report/get-assigned-order-queued-reports?${typeFilter}${filterQuery}&page=${pageNumber}&paginate=${pagination}`, {
    })
  },
  fetchAssignedOrderReportDownloadsNoPagination(filterQuery, queueReportType = '') {
    const typeFilter = queueReportType ? `filter[report_type]=${encodeURIComponent(queueReportType)}&` : ''
    return ReportsRepository.get(`/admin/report/get-assigned-order-queued-reports?${typeFilter}${filterQuery}`, {
    })
  },
  queueAssignedOrdersExcelDownload(reportType, filterQuery) {
    return ReportsRepository.post(`/admin/report/queue/assigned-orders-excel-download?report_type=${reportType}&${filterQuery}`)
  },
  fetchOperationalOrdersByStatus(key, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`/admin/report/get-current-status/${key}?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=-id`)
  },
  fetchOperationalOrdersByStatusNoPagination(key, filterQuery) {
    return ReportsRepository.get(`/admin/report/get-current-status/${key}?${filterQuery}&sort=-id&noPagination`)
  },
  getBranchDeliveryProgressSuccessAndFailure(warehouseId) {
    return ReportsRepository.get(`${branchDeliveryDashboardResource}/success-failure?warehouse_id=${warehouseId}`)
  },
  getBranchDeliveryProgressTopTen() {
    return ReportsRepository.get(`${branchDeliveryDashboardResource}/top-ten`)
  },
  getBranchDeliveryProgressReport(pageNumber = 1, filterQuery, pagination = defaultPagination, warehouseId, month) {
    return ReportsRepository.get(`/admin/report/pending-branch-delivery-report?paginate=${pagination}&page=${pageNumber}&warehouse_id=${warehouseId}&month_key=${month}&${filterQuery}`)
  },
  getBranchDeliveryProgressReportNoPagination(filterQuery, warehouseId, month) {
    return ReportsRepository.get(`/admin/report/pending-branch-delivery-report?warehouse_id=${warehouseId}&month_key=${month}&${filterQuery}&sort=-id&noPagination`)
  },
  getTemporaryWarehouseReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${temporaryWarehouseReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=-id`)
  },
  getTemporaryWarehouseReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${temporaryWarehouseReport}?${filterQuery}&sort=-id&noPagination`)
  },
  getAssignOrderSummeryReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`/admin/report/warehouse-order-count-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAssignOrderSummeryReportNoPagination(filterQuery) {
    return ReportsRepository.get(`/admin/report/warehouse-order-count-report?${filterQuery}&sort=-id&noPagination`)
  },
  getMerchantInactivationReport(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ReportsRepository.get(`${merchantInactivationReport}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getMerchantInactivationReportNoPagination(filterQuery) {
    return ReportsRepository.get(`${merchantInactivationReport}?${filterQuery}&sort=-id&noPagination`)
  },
}
